// isLive: "/feed/perfumes-club-ae5376" -> "/feed/perfumes-club", which the API
// resolves to the brand's live campaign. Other statuses keep the full code.
export const toCampaignShareLink = (link: string, isLive = false): string => {
  if (!link) return link;

  try {
    const url = new URL(link);

    // "/1b733b" -> "/feed/1b733b"; already /feed/... is kept as-is
    if (!url.pathname.startsWith('/feed/')) {
      const slug = url.pathname.replace(/^\/+/, '');
      if (!slug) return link;
      url.pathname = `/feed/${slug}`;
    }
    if (isLive) url.pathname = url.pathname.replace(/-[0-9a-f]{6}$/, '');

    return url.toString();
  } catch {
    return link;
  }
};
